import { Component, computed, inject, input, signal } from "@angular/core"
import { RouterLink } from "@angular/router"
import { IntroGradeData } from "../intro.model"
import { NgOptimizedImage } from "@angular/common"
import { StorageService } from "../../../../services/storage.service"

@Component({
  imports: [
    RouterLink,
    NgOptimizedImage,
  ],
  standalone: true,
  template: `
    @let data = grade();
    @if (data) {
      <div
        style="width: 50%"
        class="cursor-pointer relative brightness-125 z-10"
        role="button"
        tabindex="0"
        aria-haspopup="dialog"
        [aria-label]="ariaLabel()"
        [routerLink]="[]"
        [fragment]="data.grade.toLowerCase()"
        queryParamsHandling="preserve"
        (mouseover)="hover.set(true)"
        (mouseout)="hover.set(false)"
      >
        <img
          disableOptimizedSrcset
          alt=""
          aria-hidden="true"
          [ngSrc]="imageMapMapSrc()"
          style="transition: all 0.5s ease-out; position: relative"
          [style.aspect-ratio]="aspectRatio()"
          [style.filter]="hover() ? 'opacity(0.1)' : 'opacity(1)'"
          fill
        >
        <!--
                  style="height: unset"
                  [style.width]="data.imageMap.style.width"
                  [width]="data.imageMap.width"
                  [height]="data.imageMap.height"
        -->
        <div
          class="absolute top-[1px] left-0 w-full brightness-125"
        >
          <img
            [alt]="data.imageMap.altText"
            [ngSrc]="imageMapZoneSrc()"
            style="position: relative"
            [style.aspect-ratio]="aspectRatio()"
            fill
          >
        </div>
      </div>
    }
  `,
  selector: "e2e-grade",
})
export class GradeComponent {
  private storageService = inject(StorageService)

  grade = input.required<IntroGradeData>()
  // visiblePercent = input<number>(1)
  aspectRatio = input.required<number>()

  hover = signal(false)
  imageMapMapSrc = computed(() =>
    this.storageService.getFileUrl(this.grade().imageMap.map_src)
  )
  imageMapZoneSrc = computed(() =>
    this.storageService.getFileUrl(this.grade().imageMap.zone_src)
  )

  ariaLabel = computed(() => {
    return `Grade ${this.grade().grade}, color coded ${this.grade().grade}: ${this.grade().description}. Click to view historical info.`
  })

/*
  scrollOpacity = computed(() => {
    const opacity = Math.abs(this.visiblePercent() - 1.5)
    // console.log(opacity)
    if (opacity < 0.5 ) return "opacity(0.5)"
    return "opacity(" + opacity * 1.5 + ")"
  })
*/
}
